import { RegisterVerifiedCompanyWithConnectBoardMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerVerifiedCompanyWithConnectBoardHandler =
  graphql.mutation<RegisterVerifiedCompanyWithConnectBoardMutation>(
    "registerVerifiedCompanyWithConnectBoard",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerVerifiedCompanyWithConnectBoard: {
            token: {
              id_token: "mock_id_token",
              access_token: "mock_access_token",
              refresh_token: "mock_refresh_token",
              token_type: "Bearer",
            },
          },
        },
      });
    }
  );
